/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_NameInputs */



/**
* | output |
* | --- |
* | "Room name" |
*
* @param {Rooms_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_name = /** @type {((inputs?: Rooms_NameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_NameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de la salle")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de la sala")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome da sala")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome della sala")
	return /** @type {LocalizedString} */ ("Room name")
});